import { css, styled } from '@lichtblick/styled';
import { BorderRadius } from '@lichtblick/theme';

export const ImageContainer = styled.div<{ $ratio: number }>`
  align-items: center;
  border-radius: ${BorderRadius.S};
  display: flex;
  justify-content: center;
  margin: 2rem auto;
  max-width: 90vw;
  overflow: visible;
  position: relative;

  ${({ $ratio }) => {
    return $ratio > 1
      ? css`
          min-height: ${720 / $ratio}px;
          min-width: 45rem;
        `
      : css`
          min-height: 45rem;
          min-width: ${720 * $ratio}px;
        `;
  }}
`;

export const RotationControls = styled.div`
  bottom: 16px;
  display: flex;
  gap: 8px;
  position: absolute;
  right: 16px;
  z-index: 2;
`;
